<template>
  <div>
    <div class="bg-content padding15">
      <el-form size="small" label-width="55px" ref="searchRef" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="条件">
              <el-input v-model="searchReq.key" placeholder="请输入权限码/功能名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-select v-model="searchReq.parentsName" filterable multiple collapse-tags placeholder="请选择功能类型" style="width: 100%;">
                <el-option v-for="item in parentNameRes" :key="item" :label="item" :value="item" :title="item"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态">
              <el-select style="width:100%" placeholder="请选择状态" v-model="searchReq.status" clearable>
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="small" plain @click="roleTableVisable = false; searchReq.page = 1; permissionList();"> <i class="fa fa-search"></i> 搜索</el-button>
            <el-button size="small" @click="searchReq.key = null; searchReq.parentsName = []; searchReq.status = null;">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" size="small" style="float:right;" @click="addVisable" v-if="this.$hasPerm('Z017')">添加权限</el-button>
    </div>
    <div class="padding15 bg-content">
      <el-table size="small" :data="permissionRes.list" @sort-change="sort" @row-click="rowClick">
        <!--<el-table-column fixed property="id"  label="ID" min-width="50px"/>-->
        <el-table-column fixed property="permissionCode"  label="权限码" min-width="100px"/>
        <el-table-column fixed property="permissionName"  label="功能名称" min-width="160px"/>
        <el-table-column fixed property="parentsName"  label="功能类型" min-width="160px"/>
        <el-table-column fixed label="状态" min-width="70px">
          <template slot-scope="scope">
            <span v-if="scope.row.status === '1'">开启</span>
            <span v-else>关闭</span>
          </template>
        </el-table-column>
        <el-table-column fixed label="默认" min-width="70px">
          <template slot-scope="scope">
            <div v-if="scope.row.common === 1" style="color: #F56C6C;">是</div>
            <div v-else style="color: #67C23A;">否</div>
          </template>
        </el-table-column>
        <el-table-column fixed property="createTime"  label="创建时间" min-width="140px" sortable="custom"/>
        <el-table-column fixed property="updateTime"  label="更新时间" min-width="140px" sortable="custom"/>
        <el-table-column fixed label="操作" min-width="140px" v-if="this.$hasPerm('Z017')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateVisable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
            <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :total="permissionRes.totalRecords"
          :page-size="searchReq.limit"
          :current-page="searchReq.page"
          @current-change="currentChange"
          @size-change="sizeChange">
        </el-pagination>
      </div>
    </div>
    <!--角色列表-->
    <div class="padding15-tb" v-if="roleTableVisable">
      <div class="padding15-tb">
        <el-table size="small" highlight-current-row :data="roleRes.list" @selection-change="selectionChange">
          <el-table-column fixed="left" width="50" type="selection" :selectable="selectable"/>
          <el-table-column property="companyName" fixed label="公司名称"/>
          <el-table-column property="roleName" fixed label="角色名称"/>
          <el-table-column label="默认角色">
            <template slot-scope="scope">
              <div v-if="scope.row.common == 1" style="color: #F56C6C;">是</div>
              <div v-else style="color: #67C23A;">否</div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status === '0'" style="color: #F56C6C;">禁用</div>
              <div v-if="scope.row.status === '1'" style="color: #67C23A;">启用</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="removeRoleRelation(scope.row)" v-if="scope.row.common == 0" size="small"><i class="el-icon-delete"></i>删除</el-button>&nbsp;&nbsp;
            </template>
          </el-table-column>
        </el-table>
        <div class="text center margin15-tb">
          <el-pagination background layout="prev, pager, next, sizes, total"
                         :total="roleRes.totalRecords"
                         :page-size="roleReq.limit"
                         :current-page="roleReq.page"
                         @current-change="roleCurrentChange"
                         @size-change="roleSizeChange">
          </el-pagination>
        </div>
        <div style="margin-top: 10px">
          <el-button @click="batchRemoveRoleRelation">删除</el-button>
        </div>
      </div>
    </div>
    <!-- 添加权限 -->
    <el-dialog :title="title+'权限'" :visible.sync="permissionVisible" width="50%" center>
      <div>
        <el-form size="small" label-width="140px">
          <el-form-item label="权限码">
            <el-input placeholder="请输入权限码" v-model="reqBody.permissionCode"/>
          </el-form-item>
          <el-form-item label="功能名称">
            <el-input placeholder="请输入功能名称" v-model="reqBody.permissionName"/>
          </el-form-item>
          <el-form-item label="功能类型">
            <el-input placeholder="请输入功能类型" v-model="reqBody.parentsName"/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width:100%" placeholder="请选择状态" v-model="reqBody.status" >
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="reqBody.common" :true-label="1" :false-label="0">为甲方公司默认可见权限</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add" size="small" v-if="addShow">保存</el-button>
        <el-button type="primary" @click="update" size="small" v-if="!addShow">更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      permissionVisible: false,
      searchReq: {
        page: 1,
        limit: 10,
        key: null,
        status: null,
        parentsName: [],
        order: 'update_time',
        sort: 'desc'
      },
      permissionRes: { 'totalRecords': 0, list: [] },
      parentNameRes: [],
      reqBody: {
        id: null,
        permissionName: null,
        permissionCode: null,
        parentsName: null,
        status: null,
        common: 0
      },
      status: [
        {
          label: '开启',
          value: '1'
        }, {
          label: '关闭',
          value: '0'
        }
      ],
      addShow: true,
      title: null,
      roleTableVisable: false,
      roleReq: {
        permissionId: null,
        permissionName: null,
        page: 1,
        limit: 10,
        order: 'update_time',
        sort: 'desc'
      },
      roleRes: { 'totalRecords': 0, list: [] },
      removeRoles: []
    };
  },
  methods: {
    addVisable() {
      this.title = '创建';
      this.clearReq();
      this.permissionVisible = true;
      this.addShow = true;
    },
    add() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/permission/add',
        data: this.reqBody
      }).then(() => {
        this.permissionVisible = false;
        // 刷新
        this.permissionList();
      });
    },
    updateVisable(row) {
      this.title = '编辑';
      this.clearReq();
      this.permissionVisible = true;
      this.addShow = false;

      // 设置内容
      this.reqBody.id = row.id;
      this.reqBody.permissionName = row.permissionName;
      this.reqBody.permissionCode = row.permissionCode;
      this.reqBody.parentsName = row.parentsName;
      this.reqBody.status = row.status;
      this.reqBody.common = row.common;
    },
    update() {
      this.$ajax({
        method: 'GET',
        url: `/permission/used/${this.reqBody.id}`
      }).then((res) => {
        this.$confirm(`该权限正在被${res.data}个角色使用，确定仍要更新吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax({
            prompt: true,
            method: 'POST',
            url: `/permission/update/${this.reqBody.id}`,
            data: this.reqBody
          }).then(() => {
            this.permissionVisible = false;
            // 刷新
            this.permissionList();
          });
        });
      });
    },
    remove(permissionId) {
      this.$ajax({
        method: 'GET',
        url: `/permission/used/${permissionId}`
      }).then((res) => {
        if (res.data > 0) {
          this.$notify.error({
            title: '提示',
            message: `该权限正在被${res.data}个角色使用，请先将使用该权限的角色更新至其他权限后再行删除。`
          });
        } else {
          this.$confirm('您确定要删除该权限吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$ajax({
              prompt: true,
              method: 'DELETE',
              url: `/permission/remove/${permissionId}`
            }).then(() => {
              // 刷新
              this.roleTableVisable = false;
              this.permissionList();
            });
          });
        }
      });
    },
    permissionList() {
      this.$ajax({
        method: 'POST',
        url: '/permission/list',
        data: this.searchReq
      }).then((res) => {
        this.permissionRes = res.data;
      });
    },
    parentNameList() {
      this.$ajax({
        method: 'GET',
        url: '/permission/parentName'
      }).then((res) => {
        this.parentNameRes = res.data;
      });
    },
    sort(column) {
      const prop = column.prop === null ? 'updateTime' : column.prop;
      const order = column.order === null ? 'descending' : column.order;
      this.searchReq.order = prop;
      if (order === 'descending') {
        this.searchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.searchReq.sort = 'asc';
      }
      this.permissionList();
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.permissionList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.permissionList();
    },
    clearReq() {
      this.reqBody.id = null;
      this.reqBody.permissionName = null;
      this.reqBody.permissionCode = null;
      this.reqBody.parentsName = null;
      this.reqBody.status = null;
      this.reqBody.common = 0;
    },
    rowClick(row) {
      this.roleReq.permissionId = row.id;
      this.roleReq.permissionName = row.permissionName;
      this.roleReq.page = 1;
      this.roleList();
    },
    roleList() {
      this.roleTableVisable = true;
      this.$ajax({
        method: 'POST',
        url: `/permission/role/${this.roleReq.permissionId}`,
        data: this.roleReq
      }).then((res) => {
        this.roleRes = res.data;
      });
    },
    removeRoleRelation(row) {
      this.$confirm(`您确定要解除权限:${this.roleReq.permissionName},与角色:${row.roleName}的关系吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/permission/removeRoleRelation/${this.roleReq.permissionId}/${row.id}`
        }).then(() => {
          // 刷新
          this.roleList();
        });
      });
    },
    selectionChange(val) {
      this.removeRoles = val;
    },
    batchRemoveRoleRelation() {
      if (this.removeRoles.length === 0) {
        this.$notify.error({
          title: '提示',
          message: '请选择删除的角色'
        });
        return;
      }
      const ids = [];
      const names = [];
      let index = 0;
      let more = '';
      this.removeRoles.forEach((item) => {
        if (index <= 5) {
          ids.push(item.id);
          names.push(`${item.companyName}-${item.roleName}`);
        } else {
          more = '...';
        }
        index += 1;
      });
      this.$confirm(`您确定要解除权限,"${this.roleReq.permissionName}"与角色"${names}${more}"的关系吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          data: {
            roleIds: ids
          },
          url: `/permission/removeRoleRelation/${this.roleReq.permissionId}`
        }).then(() => {
          // 刷新
          this.roleList();
        });
      });
    },
    roleCurrentChange(page) {
      this.roleReq.page = page;
      this.roleList();
    },
    // 显示条数
    roleSizeChange(num) {
      this.roleReq.limit = num;
      this.roleList();
    },
    selectable(row) {
      if (row.common === 1) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.permissionList();
    this.parentNameList();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/permission/permission.vue